//M002 header background-color
function initHeaderBar() {

    if ($(".headerBarMenuLink").length > 0) {

        $('#headerBarMenuContentLink').on("keydown", handleKeyDownForClick);


        $("#headerBarMenuContentLink").on("click", function () {

            if ($(".headerBarLogin").children(".container").hasClass("active")) {
                closeLoginBar();
            }

            if ($(".headerBarContent").children(".container").hasClass("active")) {
                closeHeaderBar();
            }
            else {

                hideMainNavigationOpened();

                $(".headerBarContentBox").hide();
                $(".headerBarMenuElement").removeClass("active");
                $(this).addClass("active");

                $(".headerBarContent").children(".container").removeClass("absolute");
                $(".headerBarContent").children(".container").addClass("absolute");
                $(".headerBarContent").css("min-height", 0);
                $(".headerBarContent").css("height", 1);
                $(".headerBarContent").show();

                var targetHeight = Math.ceil($(".headerBarContent").children(".container").height() + 20);

                $(".headerBarContent").animate({
                        height: targetHeight
                    },
                    {
                        duration: 500,
                        easing: "swing",
                        complete: function () {
                            $(".headerBarContent").children(".container").removeClass("absolute");
                            $(".headerBarContent").children(".container").addClass("active");
                            $(".headerBarContent").css("min-height", targetHeight);
                            $(".headerBarContent").css("height", "auto");
                            
                            if(!$("main").hasClass("navigation-opened")){
                                $("main").addClass("navigation-opened");
                            }
                        }
                    }
                );

            }

            updateHeaderBar();
        });
    }

    $('#headerBarMenuLoginLinkMobile').on("keydown", handleKeyDownForClick);
    $("#headerBarMenuLoginLinkMobile").on("click", function () {
        if($("#mobileNavigation").hasClass("mobileNavigation--opened")){
            //close mobile navi
            $(".slicknav_open").trigger("click");

            //show login layer
            $(".headerBarLogin").show();
            $(".headerBarLogin").css("height", "auto");
            $(".headerBarLogin").children(".container").addClass("active");
        }
    });
    
    $('#headerBarMenuLoginLink').on("keydown", handleKeyDownForClick);
    $("#headerBarMenuLoginLink").on("click", function () {

        if($(this).hasClass("headerBarMenuElement--flyout")){

            /*
            $(".headerBarContentBox").hide();
            $(".headerBarMenuElement").removeClass("active");
            $(this).addClass("active");

            var lft = Math.round($(this).offset().left + ($(this).width() / 2) - ($("#headerBarMenuLoginContent").width() / 2));
            $("#headerBarMenuLoginContent").css("left", lft + "px");
            $("#headerBarMenuLoginContent").fadeIn(500);

            closeHeaderBar();
            hideMainNavigationOpened();
            updateHeaderBar();

            $("main").unbind().click(function () {
            $(".headerBarContentBox").hide();
            });
            */

            if ($(".headerBarLogin").children(".container").hasClass("active")) {
                closeLoginBar();
            }
            else {
                
                hideMainNavigationOpened();
                
                $(".headerBarContentBox").hide();
                $(".headerBarMenuElement").removeClass("active");
                $(this).addClass("active");

                $(".headerBarLogin").children(".container").removeClass("absolute");
                $(".headerBarLogin").children(".container").addClass("absolute");
                $(".headerBarLogin").css("min-height", 0);
                $(".headerBarLogin").css("height", 1);
                $(".headerBarLogin").show();

                updateHeaderBarLogin();

                if(!$("main").hasClass("navigation-opened")){
                    $("main").addClass("navigation-opened");
                }
            }

            if ($(".headerBarContent").children(".container").hasClass("active")) {
                closeHeaderBar();
            }

            updateHeaderBar();
            updateFormFieldSize();

            setTimeout(updateFormFieldSize, 1000);
            setTimeout(updateFormFieldSize, 2500);
            setTimeout(updateFormFieldSize, 5000);
        }

    });

    $('#headerBarMenuLanguageLink').on("keydown", handleKeyDownForClick);

    $("#headerBarMenuLanguageLink").on("click", function () {
        $(".headerBarContentBox").hide();
        $(".headerBarMenuElement").removeClass("active");
        $(this).addClass("active");

        var lft = Math.round($(this).offset().left + ($(this).width() / 2) - ($("#headerBarMenuLanguageContent").width() / 2));
        $("#headerBarMenuLanguageContent").css("left", lft + "px");
        $("#headerBarMenuLanguageContent").fadeIn(500);

        closeHeaderBar();
        closeLoginBar();
        hideMainNavigationOpened();
        updateHeaderBar();

        $("main").unbind().click(function () {
            $(".headerBarContentBox").hide();
        });
    });

    //close button click handling
    $(".headerBarContentCloseButton").click(function () {
        closeHeaderBar();
        closeLoginBar();
    });
    $(".headerBarContentCloseButton").on("keydown", handleKeyDownForClick);

    //hover colors for icons
    if ($(".headerBarContentTeaser").length > 0) {
        $(".headerBarContentTeaser").each(function () {

            $(this).mouseover(function(){
                $(this).find(".headerBarContentTeaserIcon").removeClass("hovered");
                $(this).find(".headerBarContentTeaserIcon").addClass("hovered");
            });
            $(this).mouseout(function(){
                $(this).find(".headerBarContentTeaserIcon").removeClass("hovered");
            });
        });
    }     
}

function updateHeaderBarLogin(){

	if($("#headerBarMenuLoginLink").hasClass("active")){
		
		var targetHeight = Math.ceil($(".headerBarLogin").children(".container").height());
		
		$(".headerBarLogin").animate({
			height: targetHeight
		},
		{
				duration: 500,
				easing: "swing",
				complete: function () {
					$(".headerBarLogin").children(".container").removeClass("absolute");
					$(".headerBarLogin").children(".container").addClass("active");
					$(".headerBarLogin").css("min-height", targetHeight);
					$(".headerBarLogin").css("height", "auto");
				}
			}
		);
	}
}

function closeHeaderBar() {

    $(".headerBarContent").children(".container").removeClass("active");
    $(".headerBarMenuLink").parent(".headerBarMenuElement").removeClass("active");
    $(".headerBarContent").css("min-height", 0);

    $(".headerBarContent").animate({
            height: 1
        },
        {
            duration: 500,
            easing: "swing",
            complete: function () {
                $(".headerBarContent").hide();

                if(!$(".mainNavigationOpened").hasClass("opened")){
                    var headerNavActive = $(".headerBarContent").children(".container").hasClass("active");
                    var headerLoginActive = $(".headerBarLogin").children(".container").hasClass("active");
                    if(!headerNavActive && !headerLoginActive){
                        $("main").removeClass("navigation-opened");
                    }
                }
            }
        }
    );
}

function closeLoginBar() {

    $(".headerBarLogin").children(".container").removeClass("active");
    $(".headerBarMenuLink").parent(".headerBarMenuElement").removeClass("active");
    $(".headerBarLogin").css("min-height", 0);

    $(".headerBarLogin").animate({
            height: 1
        },
        {
            duration: 500,
            easing: "swing",
            complete: function () {
                $(".headerBarLogin").hide();

                if(!$(".mainNavigationOpened").hasClass("opened")){
                    var headerNavActive = $(".headerBarContent").children(".container").hasClass("active");
                    var headerLoginActive = $(".headerBarLogin").children(".container").hasClass("active");
                    if(!headerNavActive && !headerLoginActive){
                        $("main").removeClass("navigation-opened");
                    }
                }
            }
        }
    );
}

function updateHeaderBar() {

    //consolog("updateHeaderBar()");

    if ($(".headerBarContentTeaserCol").length > 0) {
        var h1 = 0;
        var h2 = 0;
        $(".headerBarContentTeaserCol").children(".headerBarContentTeaserColHeadline").css("height", "auto");
        $(".headerBarContentTeaserCol").find(".headerBarContentTeaserText").css("height", "auto");

        $(".headerBarContentTeaserCol").each(function () {
            if ($(this).children(".headerBarContentTeaserColHeadline").outerHeight() > h1) {
                h1 = $(this).children(".headerBarContentTeaserColHeadline").outerHeight();
            }
            if ($(this).find(".headerBarContentTeaserText").outerHeight() > h2) {
                h2 = Math.ceil($(this).find(".headerBarContentTeaserText").outerHeight());
            }
        });

        //consolog("updateHeaderBar() h:" + h);
        if (h1 > 0) {
            $(".headerBarContentTeaserCol").children(".headerBarContentTeaserColHeadline").css("height", h1 + "px");
        }
        if (h2 > 0) {
            $(".headerBarContentTeaserCol").find(".headerBarContentTeaserText").css("height", h2 + "px");
        }

        $('.col-eq-height').matchHeight(true);

		if (_blazy) {
			_blazy.revalidate();
		}
    }

}